import produce from 'immer';
import { isSortArgArray } from 'lib-shared-api-utils';
import {
  ReadAdvancedSearchResultsApiArg,
  ReadSearchApiArg,
  SearchScope,
} from 'lib-shared-types-api';
import { SearchParams } from 'lib-shared-url';
import moment from 'moment-timezone';

import { isDateCondition } from 'app/views/layout/views/search/utils/date/isDateCondition';

/**
 * Creates read search results endpoint search params.
 *
 * @param type The search result type.
 * @param arg The read search api arg.
 */
export function createReadSearchResultsSearchParams(
  type: SearchScope,
  arg: ReadSearchApiArg,
): SearchParams {
  const strict = arg.strict;
  const facets = arg.filter?.facets;
  const facetFilters = facets
    ? Object.keys(facets)
        .map((key) =>
          [...new Set<string>(facets[key])]
            .map((value) => [key, value].join(':'))
            .join(','),
        )
        .join(',')
    : undefined;

  const sortBy = arg.sort
    ? isSortArgArray(arg.sort)
      ? arg.sort
          .map(({ key, direction }) => `${key}:${direction || 'asc'}`)
          .join(',')
      : `${arg.sort.key}:${arg.sort.direction || 'asc'}`
    : undefined;

  return {
    scope: type,
    strict,
    facetFilters,
    sortBy,
  };
}

export function transformReadAdvancedSearchResultsArg({
  params,
}: ReadAdvancedSearchResultsApiArg): ReadAdvancedSearchResultsApiArg {
  return {
    params: produce(params, (draftParams) => {
      if (draftParams.filters) {
        draftParams.filters.conditions.forEach((condition) => {
          if (isDateCondition(condition)) {
            condition.meta = { timezone: moment.tz.guess() };
          }
        });
      }

      // Pagination is 1-based in the frontend and 0-based in the backend
      draftParams.page = (draftParams.page ?? 1) - 1;
    }),
  };
}
